import {useLocation, useOutletContext} from "react-router-dom";

import {PermitApplicationDocReviewFormFields, PermitForm} from "./form";
import {FormContainer} from "base/form/components";
import {usePermitApplicationForm} from "permitapplication/hooks/PermitApplicationFormHook";

const PermitApplicationDocReviewStep = () => {
    const {permit, isStepEditable} = useOutletContext();

    const basePath = useLocation();

    const fileFields = [
        "application_doc",
        "personal_id_doc",
        "plot_ownership_doc",
        "plot_use_authorization",
        "tax_id_doc",
    ];

    const {handleFormSubmit} = usePermitApplicationForm(permit, basePath, fileFields);

    return (
        <PermitForm permit={permit} onSubmit={handleFormSubmit}>
            <FormContainer>
                <PermitApplicationDocReviewFormFields disabled={!isStepEditable} />
            </FormContainer>
        </PermitForm>
    );
};

export default PermitApplicationDocReviewStep;
